export interface SearchCriteria {
    filter_groups?: Array<FilterGroup>;
}

interface FilterGroup {
  filters: Array<Filter>;
}

interface Filter {
 field: string;
 value: string;
 test?: string;
}

/**
 * Create filter to use in API call
 */
export class APIFilter {
 private filters: Array<Filter> = [];

 /**
  * Add simple filter key / value
  * @param field
  * @param value
  */
 public simple(field: string, value: string): APIFilter {
     this.filters.push({field, value});
     return this;
 }

 /**
  * Retrieve query parameters as key=value pair
  */
 public queryParameters(): Array<string> {
    const params: Array<string> = [];
    this.filters.forEach(filter => {
        params.push(filter.field + '=' + filter.value);
    });
    return params;
 }

}
